import React, { FC, memo, MouseEventHandler } from "react";
import classnames from "classnames";

/**
 * Fancy expand/collapse icon button, which should be rendered inside AgGrid
 */
const AgExpandButton: FC<{
    expanded?: boolean;
    onClick?: MouseEventHandler<HTMLSpanElement>;
    onDoubleClick?: MouseEventHandler<HTMLSpanElement>;
}> = ({ expanded, onClick, onDoubleClick }) => {
    return (
        <>
            <span className={classnames("ag-group-expanded", { "ag-hidden": !expanded })}>
                <span
                    className="ag-icon ag-icon-tree-open"
                    unselectable="on"
                    role="presentation"
                    onClick={onClick}
                    onDoubleClick={onDoubleClick}
                />
            </span>
            <span className={classnames("ag-group-contracted", { "ag-hidden": expanded })}>
                <span
                    className="ag-icon ag-icon-tree-closed"
                    unselectable="on"
                    role="presentation"
                    onClick={onClick}
                    onDoubleClick={onDoubleClick}
                />
            </span>
        </>
    );
};

export default memo(AgExpandButton);
